import React, { useRef, useEffect } from "react";

/** 6-digit verification code input. Pass `value` as the joined string and `onChange(s)`. */
export const CodeInput = ({ value = "", onChange, disabled, autoFocus = true, testIdPrefix = "code" }) => {
    const inputs = useRef([]);

    const setAt = (i, ch) => {
        const arr = (value || "").padEnd(6, "").split("");
        arr[i] = ch;
        const next = arr.join("").replace(/[^0-9]/g, "").slice(0, 6);
        onChange(next);
    };

    useEffect(() => {
        if (autoFocus && inputs.current[0]) inputs.current[0].focus();
    }, [autoFocus]);

    const onKeyDown = (e, i) => {
        if (e.key === "Backspace" && !value[i] && i > 0) {
            inputs.current[i - 1]?.focus();
        }
    };

    const onChangeChar = (e, i) => {
        const ch = e.target.value.replace(/[^0-9]/g, "").slice(-1);
        if (ch) {
            setAt(i, ch);
            if (i < 5) inputs.current[i + 1]?.focus();
        } else {
            setAt(i, "");
        }
    };

    const onPaste = (e) => {
        e.preventDefault();
        const txt = (e.clipboardData.getData("text") || "").replace(/[^0-9]/g, "").slice(0, 6);
        if (!txt) return;
        onChange(txt);
        const focusIdx = Math.min(txt.length, 5);
        inputs.current[focusIdx]?.focus();
    };

    return (
        <div className="flex items-center gap-2 sm:gap-3 justify-center" onPaste={onPaste}>
            {Array.from({ length: 6 }).map((_, i) => (
                <input
                    key={i}
                    ref={(el) => (inputs.current[i] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    pattern="[0-9]*"
                    disabled={disabled}
                    data-testid={`${testIdPrefix}-${i}`}
                    value={value[i] || ""}
                    onChange={(e) => onChangeChar(e, i)}
                    onKeyDown={(e) => onKeyDown(e, i)}
                    className="w-11 h-14 sm:w-12 sm:h-16 text-center text-2xl font-bold rounded-2xl border-2 border-border bg-background focus:border-foreground focus:outline-none transition-colors"
                />
            ))}
        </div>
    );
};
